import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController, IonSlides } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Recipe, RecipePartsEnum } from 'src/app/models/recipe.model';

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RecipeComponent implements OnInit {
  @ViewChild('slider', { read: IonSlides, static: false }) slider: IonSlides;
  @Input() recipe: Recipe;
  currentTabValue: string = RecipePartsEnum.ingredients;

  get imgUrl() {
    let imgPath = '';
    if (this.recipe) {
      imgPath = './assets/images/recipes/' + (this.recipe?.image ?? 'empty.png');
      // imgPath = './assets/images/recipes/' + this.recipe?.portraitImgName;
    }
    return imgPath;
  }

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    autoplay: false,
    onlyExternal: false
  };

  constructor(
    public modalController: ModalController,
    private translate: TranslateService,
  ) {

  }

  ionViewDidEnter() {
    // this.slider.slideTo(0);
    // this.slider.update();
    // this.slideChange();
  }

  ngOnInit() {
    if (!this.recipe?.ingredients) {
      this.slideOpts.initialSlide = 1;
    }
  }

  close() {
    this.modalController.dismiss();
  }

  segmentChanged(ev: any) {
    const value = ev.detail.value;
    if (value === RecipePartsEnum.ingredients) {
      this.slider.slideTo(0);
    } else {
      this.slider.slideTo(1);
    }
  }

  slideChange() {
    this.slider.getActiveIndex().then(index => {
      this.currentTabValue = (index === 0) ? RecipePartsEnum.ingredients : RecipePartsEnum.instructions;
    });
  }
}
